import React from 'react';
import { Card, CardContent } from '@/Components/ui/card';
import { Heading, Text } from '@/Components/ui/typography';
import { Stack, Inline } from '@/Components/ui/layout';
import { Separator } from '@/Components/ui/separator';
import { Globe, MapPin, Phone, Mail } from 'lucide-react';

function ContactInfo({profileData}) {
  const contactItems = [
    { icon: Globe, label: 'WEBSITE', value: profileData.data.website },
    { icon: MapPin, label: 'LOCATION', value: profileData.data.city },
    { icon: Phone, label: 'PHONE', value: profileData.data.phone },
    { icon: Mail, label: 'EMAIL ADDRESS', value: profileData.data.email }
  ];

  return (
    <Card className="rounded-lg border-[1.5px] border-blue-100 bg-white flex mt-6 max-w-full w-[312px] flex-col p-6">
      <CardContent className="p-0">
        <Heading level="h2" size="base" className="font-medium text-slate-900 m-0">
          Contact Information
        </Heading>
        <Stack spacing="md" className="mt-6 w-full max-w-[264px] flex-col">
          {contactItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <React.Fragment key={index}>
                <Inline spacing="md" className="items-start gap-4">
                  <Icon className="w-8 h-8 text-slate-600 flex-shrink-0" />
                  <Stack spacing="xs" className="flex-col w-[216px]">
                    <Text size="xs" className="text-slate-500 font-normal uppercase">
                      {item.label}
                    </Text>
                    <Text size="sm" className="text-slate-900 font-medium leading-none mt-1">
                      {item.value}
                    </Text>
                  </Stack>
                </Inline>
                {index < contactItems.length - 1 && (
                  <Separator className="bg-slate-200 min-h-[1px] my-5 w-full border border-slate-200" />
                )}
              </React.Fragment>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default ContactInfo;